'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _module$exports;

var _digital = require('-!svg-react-loader!../../assets/images/change-provider/digital-3.svg');

var _digital2 = _interopRequireDefault(_digital);

var _phisical = require('-!svg-react-loader!../../assets/images/change-provider/phisical4.svg');

var _phisical2 = _interopRequireDefault(_phisical);

var _sellerTypes = require('./sellerTypes');

var _sellerTypes2 = _interopRequireDefault(_sellerTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (_module$exports = {}, (0, _defineProperty3.default)(_module$exports, _sellerTypes2.default.digital, (0, _digital2.default)({
  width: '96',
  height: '96',
  viewBox: '0 0 96 96'
})), (0, _defineProperty3.default)(_module$exports, _sellerTypes2.default.digitalAndPrints, (0, _phisical2.default)({
  width: '96',
  height: '96',
  viewBox: '0 0 96 96'
})), _module$exports);